import React, {useState} from 'react'

const BarcodeLabelRecordContext = React.createContext(null)

function BarcodeLabelRecordContextProvider(props) {
  // [A]
  const [barcodeLabelRecord, setBarcodeLabelRecord] = useState('')

  const value = {
    setBarcodeLabelRecord,
    barcodeLabelRecord,
  }

  // [B]
  return (
    <BarcodeLabelRecordContext.Provider value={value}>
      {props.children}
    </BarcodeLabelRecordContext.Provider>
  )
}

const BarcodeLabelRecordContextConsumer = BarcodeLabelRecordContext.Consumer

export {
  BarcodeLabelRecordContext,
  BarcodeLabelRecordContextProvider,
  BarcodeLabelRecordContextConsumer,
}
